import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="state-city"
export default class extends Controller {
  static targets = ["state", "city"]

  stateChanged() {
    const state = this.stateTarget.value;
    const cepCity = this.element.getAttribute('data-cep-city')
    this.previousCity = this.cityTarget.value;
    
    if (state && !cepCity) {
      this.fetchCities(state);
    } else if (state && cepCity != this.previousCity) {
      this.addOptionsToCity({cepCity: cepCity})
    }
  }

  clicked() {
    const state = this.stateTarget.value
    const cityOptionsLength = this.cityTarget.options.length - 1;

    if(cityOptionsLength <= 1 && state) {
      this.fetchCities(state)
    }
  }

  async fetchCities(uf) {
    try {
      const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`)
      const cities = await response.json()
      
      this.addOptionsToCity({cities: cities})
    } catch (error) {
      console.error("Erro ao buscar cidades:", error)
    }
  }

  addOptionsToCity({cities = null, cepCity = null}) {
    // Remember the currently selected city before clearing
    const selectedCity = this.cityTarget.value || this.previousCity

    this.cityTarget.innerHTML = '<option value="">Selecione uma cidade</option>'

    if(cepCity) {
      this.cityTarget.innerHTML = `<option value="${cepCity}">${cepCity}</option>`
      this.cityTarget.value = cepCity
      return
    }

    cities.forEach(city => {
      const option = document.createElement('option')
      option.value = city.nome
      option.textContent = city.nome
      // Mark as selected if this was the previously selected city
      if (city.nome === selectedCity) {
        option.selected = true
      }
      this.cityTarget.appendChild(option)
    })

    // Ensure the value is set correctly
    if (selectedCity) {
      this.cityTarget.value = selectedCity
    }
  }
}